const parseDate = date => {
  return date ? Date.parse((date + 'Z').replace('ZZ', 'Z')) : null
}

const getInitials = name => {
  const words = name.split(' ')
  let initials = words[0].substring(0, 1).toUpperCase()

  if (words.length > 1) {
    initials += words[words.length - 1].substring(0, 1).toUpperCase()
  }

  return initials
}

// const formatImageUrl = url => {
//   return url
//     .replace('/modules/', '/')
//     .replace('/Images/', '/')
//     .replace('/images/', '/')
// }

export const formatCoachActivitiesResponse = ({ data }) => {
  const { coachActivities } = data
  const textByStatus = {
    available: 'Niet begonnen',
    active: 'Bezig',
    done: 'Geen actieve modules',
    closed: 'Begeleiding gestopt',
  }

  const activities = coachActivities.map(activity => {
    const {
      activities,
      program,
      id,
      key,
      fileNumber,
      startDateUtc,
      accessDateUtc,
      status,
      users,
    } = activity
    const user = users.find(user => user.role.roleName === 'User')

    return {
      id,
      initials: getInitials(user.person.nickName),
      nickName: user.person.nickName,
      email: user.person.email || '',
      clientNumber: user.person.clientNumber || '',
      fileNumber: fileNumber || '',
      key,
      startDate: startDateUtc ? Date.parse(startDateUtc) : '--',
      accessDate: accessDateUtc ? Date.parse(accessDateUtc) : '--',
      activities,
      program,
      status,
      statusText: textByStatus[status],
    }
  })

  return activities //{ coachActivities: activities }
}

export const formatCatalogsResponse = ({ data }) => {
  const categories = data.categories.map(category => {
    const { id, name } = category

    return {
      id,
      name,
      text: name,
      value: id,
    }
  })

  const products = data.products
    .map(product => {
      const { categoryIds, description, id, imageUri, name } = product
      const categories = data.categories.filter(category =>
        categoryIds.includes(category.id),
      )

      return {
        description,
        categories,
        icon: 'question',
        id,
        imgUrl: imageUri,
        name,
      }
    })
    .sort((a, b) => (a.name < b.name ? -1 : 1))

  return { categories, products }
}

export const formatClientResponse = response => {
  const textByStatus = {
    created: 'Uitgenodigd',
    available: 'Niet begonnen',
    active: 'Bezig',
    done: 'Geen actieve modules',
    closed: 'Begeleiding gestopt',
  }
  const {
    activateDateUtc,
    activities,
    accessDateUtc,
    changeDateUtc,
    closeDateUtc,
    endDateUtc,
    key,
    startDateUtc,
    status,
    users,
  } = response.data.coachActivity
  const user = users.find(user => user.role.roleName === 'User').person
  const modules = activities
    .filter(activity => !activity.program.type)
    .map(activity => {
      const {
        activateDateUtc,
        changeDateUtc,
        closeDateUtc,
        currentStep,
        endDateUtc,
        id,
        index,
        key,
        program,
        programName,
        startDateUtc,
        status,
      } = activity

      return {
        activateDate: parseDate(activateDateUtc),
        accessDate: parseDate(accessDateUtc),
        changeDate: parseDate(changeDateUtc),
        closeDate: parseDate(closeDateUtc),
        currentStep,
        endDate: parseDate(endDateUtc),
        id,
        imageUrl: program.imageUri,
        index,
        key,
        programName,
        program,
        startDate: parseDate(startDateUtc),
        status,
      }
    })
    .sort((a, b) => (a.programName < b.programName ? -1 : 1))
    .sort((a, b) => (a.index < b.index ? -1 : 1))

  return {
    activateDate: parseDate(activateDateUtc),
    accessDate: parseDate(accessDateUtc),
    changeDate: parseDate(changeDateUtc),
    closeDate: parseDate(closeDateUtc),
    endDate: parseDate(endDateUtc),
    key,
    modules,
    startDate: parseDate(startDateUtc),
    status,
    statusText: textByStatus[status],
    user: {
      ...user,
      initials: getInitials(user.nickName),
    },
  }
}

export const formatContactsResponse = response => {
  const { conversationUsers } = response.data

  const contacts = conversationUsers.map(user => {
    const { personId, nickName, email, activityKey } = user

    return {
      email,
      initials: getInitials(nickName),
      nickName,
      id: personId,
      activityKey,
    }
  })

  return contacts //{ contacts }
}

export const formatConversationDetailsResponse = response => {
  const {
    currentPersonId,
    id,
    messages,
    status,
    subject,
    type,
    updateDateUtc,
    unreadCount,
    users,
  } = response
  const typeByNumber = {
    0: 'contact',
    1: 'notification',
    2: 'request',
    4: 'news',
  }

  const formattedMessages = messages.map(message => ({
    id: message.id,
    sendDate: Date.parse(message.sendDateUtc + 'Z'),
    sender: message.sender,
    sent: message.sent ? message.sent : false,
    status: message.status && message.status.toLowerCase(),
    text: message.text,
    mimeType: message.mimeType,
    generated: message.generated,
  }))
  return {
    currentPersonId,
    date: Date.parse(updateDateUtc + 'Z'),
    id,
    messages: formattedMessages,
    status: status.toLowerCase(),
    subject: subject ? subject : '(geen onderwerp)',
    type: typeByNumber[type],
    read: unreadCount === 0 ? true : false,
    users,
  }
}

export const formatConversationResponse = response => {
  const {
    archived,
    currentPersonId,
    id,
    users,
    unreadCount,
    tags,
  } = response.data.conversation
  const recipient = users.find(user => user.personId !== currentPersonId)
  const typeByNumber = {
    0: 'none',
    1: 'generated',
    2: 'notification',
    4: 'request',
  }
  const messages = response.data.conversation.messages.map(message => {
    const {
      sendDateUtc,
      id,
      sent,
      status,
      text,
      mimeType,
      messageType,
    } = message
    return {
      sendDate: parseDate(sendDateUtc),
      id,
      sent: sent ? true : false,
      status,
      text: text ? text : '(leeg bericht)',
      mimeType,
      messageType: typeByNumber[messageType],
      generated: mimeType === 'text/html',
    }
  })
  const recentMessage = messages.reduce((acc, curr) =>
    acc.sendDateUtc > curr.sendDateUtc ? acc : curr,
  )
  const messagePreview = recentMessage.text
    ? recentMessage.text
        .replace(/<[^>]*>?/gm, '')
        .replace(/\n/g, ' ')
        .replace(/\s\s+/g, ' ')
        .trim()
        .substring(0, 70)
    : ''
  const conversation = {
    currentPersonId,
    archived,
    id,
    initials: getInitials(recipient.nickName),
    messagePreview: messagePreview,
    read: unreadCount === 0 ? true : false,
    recipient,
    unreadCount,
    tags,
    sendDate: recentMessage.sendDate,
  }
  return { conversation, messages }
}

export const formatConversationsResponse = response => {
  return response
    .map(conversation => {
      const {
        archived,
        currentPersonId,
        id,
        messages,
        unreadCount,
        users,
        tags,
      } = conversation
      const recipient = users.find(user => user.personId !== currentPersonId)
      const recentMessage = messages.reduce((acc, curr) =>
        acc.sendDateUtc > curr.sendDateUtc ? acc : curr,
      )
      const messagePreview = recentMessage.text
        ? recentMessage.text
            .replace(/<[^>]*>?/gm, '')
            .replace(/\n/g, ' ')
            .replace(/\s\s+/g, ' ')
            .trim()
            .substring(0, 70)
        : ''

      return {
        archived,
        id,
        initials: getInitials(recipient.nickName),
        messagePreview: recentMessage.text ? messagePreview : '(leeg bericht)',
        read: unreadCount === 0 ? true : false,
        recipient,
        unreadCount,
        tags,
        sendDate: parseDate(recentMessage.sendDateUtc),
      }
    })
    .sort((a, b) => b.updateDate - a.updateDate)
}

export const formatMessageResponse = response => {
  const {
    sendDateUtc,
    id,
    sent,
    status,
    text,
    mimeType,
    messageType,
  } = response
  const typeByNumber = {
    0: 'none',
    1: 'generated',
    2: 'notification',
    4: 'request',
  }
  return {
    sendDate: parseDate(sendDateUtc),
    id,
    sent: sent ? true : false,
    status,
    text: text ? text : '(leeg bericht)',
    mimeType,
    messageType: typeByNumber[messageType],
    generated: mimeType === 'text/html',
  }
}

export const formatNewConversationResponse = response => {
  const { personId, conversation } = response
  const { id, updateDateUtc, users } = conversation
  const recipient = users.find(user => user.personId !== personId)
  return {
    archived: false,
    id,
    initials: getInitials(recipient.nickName),
    messagePreview: '',
    read: true,
    recipient: recipient,
    unreadCount: 0,
    updateDate: parseDate(updateDateUtc),
  }
}

export const formatUserActivitiesResponse = response => {
  const { userActivities, authorizedActivities } = response.data
  const activities = userActivities
    .map(userActivity => userActivity.activities)
    .map(activities =>
      activities
        .filter(activity => !activity.program.type)
        .map(activity => {
          const {
            activateDateUtc,
            changeDateUtc,
            currentStep,
            currentStepName,
            closeDateUtc,
            endDateUtc,
            id,
            index,
            key,
            program,
            startDateUtc,
            status,
          } = activity
          return {
            activateDate: activateDateUtc,
            changeDate: changeDateUtc,
            closeDate: closeDateUtc,
            currentStepName: currentStepName || '',
            description: program.description || '',
            endDate: endDateUtc,
            imageUri: program.imageUri,
            index,
            id,
            key,
            name: program.programName,
            startDate: startDateUtc,
            status,
            url: `${program.uri}${currentStep || ''}?key=${key}`,
            target: program.uriTarget,
            type: program.type,
          }
        }),
    )
    .flat()
    .sort((a, b) => (a.programName < b.programName ? -1 : 1))
    .sort((a, b) => (a.index < b.index ? -1 : 1))
  return { activities, authorizedActivities }
}
